import type { Dataset, DatasetField } from '../../../services/aiConfigService';

/**
 * 树节点类型
 */
export interface TreeNode {
  key: string;
  title: string;
  type: 'dataset' | 'field';
  data?: Dataset;
  children?: TreeNode[];
  isLeaf?: boolean;
}

/**
 * 构建数据集树形结构
 * 结构：数据集 -> 字段
 */
export const buildDatasetTree = (datasets: Dataset[]): TreeNode[] => {
  return datasets.map(dataset => ({
    key: `dataset:${dataset.datasetId}`,
    title: `${dataset.datasetId} (${dataset.name})`,
    type: 'dataset',
    data: dataset,
    children: (dataset.fields || []).map((field: DatasetField) => ({
      key: `field:${field.fieldId}:${dataset.datasetId}`,
      title: `${field.fieldName} (${field.fieldType})`,
      type: 'field',
      isLeaf: true,
    })),
  }));
};
